import { render, staticRenderFns } from "./v-contact-widget.vue?vue&type=template&id=70abd389&scoped=true&"
import script from "./v-contact-widget.vue?vue&type=script&lang=js&"
export * from "./v-contact-widget.vue?vue&type=script&lang=js&"
import style0 from "./v-contact-widget.vue?vue&type=style&index=0&id=70abd389&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70abd389",
  null
  
)

export default component.exports